import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "reset-password-body" }
const _hoisted_2 = { class: "content lie" }

import { useLocale } from '@/hooks/useLocale';
import { fetchResetPassword, InputRegister, InputResetPassword } from '@/typescript/Services/Api/AuthApi';
import { SendEmailCodeAsync } from '@/typescript/Services/Api/EmailApi';
import Global from '@/utils/Global';
import Tools from '@/utils/Tools';
import { inject, ref } from 'vue';
type InputType = "login" | "register" | "forgotPassword";

export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordComponent',
  setup(__props, { expose: __expose }) {

const local = useLocale();
const active = ref<InputType>("login");
const IsMobile = inject<boolean>("IsMobile");
const TimeDown = ref<number>(0);

const resetPasswordObj = ref<InputResetPassword & {
    ResetPassword: string
}>({
    Email: "",
    EmailCode: "",
    Password: "",
    ResetPassword: ""
});

const userName = ref('');
const password = ref('');
const show = ref(false);

/**
 * 显示登录框
 */
function Show() {
    userName.value = '';
    password.value = '';
    show.value = true;
}
/**
 * 关闭登录框
 */
function Close() {
    show.value = false;
}


/**
 * 显示登录框
 */
function ShowResetPassword() {
    active.value = "login";
    Show();
}

/**
 * 发送邮件验证码
 */
function SendEmailCode(email: string) {
    if (Tools.IsNull(email)) {
        Tools.AlertError(local.t('components.ResetPasswordComponent.qsr_email'));
        return;
    }
    SendEmailCodeAsync(email).then(resp => {
        if (resp.CheckIsOk()) {
            TimeDown.value = 60;
            StartTimeDown();
            Tools.AlertSuccess(local.t('components.ResetPasswordComponent.yzmyfs'));
        }
    });
}

/**
 * 开始倒计时
 */
function StartTimeDown() {
    let timeDown = TimeDown.value;
    if (timeDown > 0) {
        TimeDown.value--;
        setTimeout(StartTimeDown, 1000);
    }
}



/**
 * 重置密码
 */
function ResetPassword() {
    fetchResetPassword(resetPasswordObj.value).then(resp => {
        if (resp.CheckIsOk()) {
            StartTimeDown();
            Tools.AlertSuccess(local.t('components.ResetPasswordComponent.czmmcg'));
        }
    });
}

__expose({
    ShowResetPassword
})


return (_ctx: any,_cache: any) => {
  const _component_VarImage = _resolveComponent("VarImage")!
  const _component_var_icon = _resolveComponent("var-icon")!
  const _component_var_input = _resolveComponent("var-input")!
  const _component_VarButton = _resolveComponent("VarButton")!
  const _component_VarSpace = _resolveComponent("VarSpace")!
  const _component_var_overlay = _resolveComponent("var-overlay")!

  return (_openBlock(), _createBlock(_component_var_overlay, {
    show: show.value,
    "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((show).value = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(['login-body lie', _unref(IsMobile) ? '' : 'pc-login-body'])
        }, [
          _createVNode(_component_VarImage, {
            width: "80",
            height: "80",
            radius: "50%",
            src: require('@/assets/logo.png')
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_var_input, {
              class: "input",
              type: "email",
              modelValue: resetPasswordObj.value.Email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((resetPasswordObj.value.Email) = $event)),
              placeholder: _ctx.$t('components.ResetPasswordComponent.email')
            }, {
              "prepend-icon": _withCtx(() => [
                _createVNode(_component_var_icon, {
                  name: "youxiang",
                  namespace: "icon"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_var_input, {
              class: "input",
              type: "text",
              modelValue: resetPasswordObj.value.EmailCode,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((resetPasswordObj.value.EmailCode) = $event)),
              placeholder: _ctx.$t('components.ResetPasswordComponent.mail_code')
            }, {
              "prepend-icon": _withCtx(() => [
                _createVNode(_component_var_icon, {
                  name: "yanzhengyanzhengma",
                  namespace: "icon"
                })
              ]),
              "append-icon": _withCtx(() => [
                (TimeDown.value > 0)
                  ? (_openBlock(), _createBlock(_component_VarButton, {
                      key: 0,
                      type: "default"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(TimeDown.value) + "s ", 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_VarButton, {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (SendEmailCode(resetPasswordObj.value.Email))),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('components.ResetPasswordComponent.fasong')), 1)
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_var_input, {
              class: "input",
              type: "password",
              modelValue: resetPasswordObj.value.Password,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((resetPasswordObj.value.Password) = $event)),
              placeholder: _ctx.$t('components.ResetPasswordComponent.dlmm')
            }, {
              "prepend-icon": _withCtx(() => [
                _createVNode(_component_var_icon, {
                  name: "mima",
                  namespace: "icon"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_var_input, {
              class: "input",
              type: "password",
              modelValue: resetPasswordObj.value.ResetPassword,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((resetPasswordObj.value.ResetPassword) = $event)),
              placeholder: _ctx.$t('components.ResetPasswordComponent.qrmm')
            }, {
              "prepend-icon": _withCtx(() => [
                _createVNode(_component_var_icon, {
                  name: "zhongfumima",
                  namespace: "icon"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_VarSpace, {
              style: {"width":"100%"},
              direction: "row",
              justify: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VarButton, {
                  class: "login-button",
                  style: {"box-sizing":"border-box","padding":"0px 20px"},
                  type: "primary",
                  onClick: ResetPassword
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('components.ResetPasswordComponent.qrcz')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_VarButton, {
                  class: "login-button",
                  style: {"box-sizing":"border-box","padding":"0px 20px"},
                  onClick: Close
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('components.ResetPasswordComponent.quxiao')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})